import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { interval, Subscription } from 'rxjs';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
import { SettingComponent } from '../setting/setting.component';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-sport-detail',
  templateUrl: './sport-detail.component.html',
  styleUrls: ['./sport-detail.component.css']
})
export class SportDetailComponent extends BaseClass<any> implements OnInit {
  @ViewChild('bookModal', { static: false }) bookModal?: ModalDirective;
  @ViewChild('betSlipModal', { static: false }) betSlipModal?: ModalDirective;
  public data: any;
  public bookDetail: any = {};
  public token: any = '';
  public fancyRun: any;
  public scoreHtml: any = '';
  public baseUrl: any = '';
  public tvSteam: any = '';
  public isLoading: boolean = false;
  public fLineMrk: boolean = false;
  public fFancyMrk: boolean = false;
  public isMobMarket: boolean = true;
  public marketsReq: any[] = [];
  public marketIds: any[] = [];
  public oodsList: any[] = [];
  public oddsLisDis: any = {};
  public exposLisDis: any = {};
  public nextExpoList: any = {};
  modalRef?: BsModalRef;
  betSlipData: any = {};
  isCollapsed = {
    match_odds: false,
    book_makers: [] as any,
    fancy: false,
    line: false,
    markets: [] as any,
    tv: {
      desktop: true,
      mobile: true
    },
    scoreTable: true
  }
  id: any = '';
  mId: any = '';
  public newOddsEnable: boolean = false;
  fancyTab: any = {};
  multiMarketIds: any[] = [];
  user: any = {}
  public raceTimer: any;
  public iframeURL: any = '';

  constructor(public service: WebserviceService,
    private actRoute: ActivatedRoute,
    public _common: CommonService,
    public _message: MessageService,
    public router: Router,
    public _shared: SharedService,
    private modalService: BsModalService,
    public _pusher: PusherService,
    protected http: HttpClient) {

    super(document);

    this.id = this.actRoute.snapshot.paramMap.get('id');
    this.mId = this.actRoute.snapshot.paramMap.get('mId');
    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
    //emit value in sequence every given second\
    const sub1 = interval(this.env.pollers.oddsData).subscribe(val => {
      if (this.id != this.actRoute.snapshot.paramMap.get('id') || (this.mId != null && this.mId != this.actRoute.snapshot.paramMap.get('mId'))) {
        this.id = this.actRoute.snapshot.paramMap.get('id');
        this.mId = this.actRoute.snapshot.paramMap.get('mId');
        this.marketsReq = [];
        this.oodsList = [];
        this.data = undefined;
        this.getEventDetail();
      }
      else if (this.baseUrl != '') {
        // this.getOdds(this.marketsReq, this.data, false);
        if (this.newOddsEnable == true) {
          this.getOddsNew(this.marketsReq, this.data, true);
        } else {
          this.getOdds(this.marketsReq, this.data, true);
        }
      }
    });
    this.subs.push(sub1);

    const sub2 = interval(this.env.pollers.scoresData).subscribe(val => {
      if (this.baseUrl != '')
        this.scoreData();
    });
    this.subs.push(sub2);

    const sub5 = interval(this.env.pollers.scoresData).subscribe(val => {
      if (this.exposLisDis)
        this.genCombineBook();
    });
    this.subs.push(sub5);

    const sub3 = this._pusher.eventUpdate(this.actRoute.snapshot.paramMap.get('id')).subscribe(res => {
      if (res.refresh == true) {
        window.location.reload();
      }
      if (res.op == 'UPDATE') {
        if (res.sub_type) {
          if (res.sub_type == 'FANCY_REMOVE') {
            if (res.m_id) {
              if (this.data?.event?.fancy != null) {
                let index: any = -1;
                this.data?.event?.fancy.forEach((element: any, i: any) => {
                  if (element.market_id == res.m_id) {
                    index = i;
                  }
                });
                // remove fancy
                if (index > -1) {
                  this.data?.event?.fancy.splice(index, 1);
                  console.log("remove fancy" + res.m_id);
                }

                // remove market id
                let fancy_index = this.marketIds.indexOf(res.m_id);
                if (fancy_index !== -1) {
                  console.log('removing from active market ' + res.m_id);
                  this.marketIds.splice(fancy_index, 1);
                }
                this.marketsReq = this.createMarketIdList(this.data.event) as any;

              } else {
                // if no fancy found
                this.getEventDetailOnly();
              }
            } else {
              // if no market id found
              this.getEventDetailOnly();
            }


          } else if (res.sub_type == 'FANCY_ADD') {
            if (res.m_id) {
              if (res.m_data) {
                // check if fanncy is not null
                if (this.data?.event?.fancy != null) {
                  // if market_id is not in marketIds then add and push to fancy
                  if (this.marketIds.indexOf(res.m_id) === -1) {
                    this.marketIds.push(res.m_id)
                    this.data?.event.fancy.push(res.m_data);
                    this.marketsReq = this.createMarketIdList(this.data.event) as any;

                    if (this.fancyTab['all'].indexOf(res.m_data.sort_priority) === -1) {
                      this.fancyTab['all'].push(res.m_data.sort_priority);
                    }
                    this.data?.event.fancy.sort((a: any, b: any) => { return a?.sort_priority - b?.sort_priority })
                  }
                } else {
                  // if no fancy found
                  this.getEventDetailOnly();
                }
              } else {
                // if no add fancy data found
                this.getEventDetailOnly();
              }
            } else {
              // if no market id found
              this.getEventDetailOnly();
            }
          } else {
            // if subtype not FANCY_ADD found
            this.getEventDetailOnly();
          }
        } else {
          // if subtype not found
          this.getEventDetailOnly();
        }

      }
    });
    this.subs.push(sub3);

    const sub4 = this._pusher.exposerUpdate(this.actRoute.snapshot.paramMap.get('id')).subscribe(res => {
      this._shared.emitUpdateExpoPusher(res);
      this.tempExpo = res.tempExposes ? [res.tempExposes] : [];
      this.setExposeData(this.data, [res.exposes]);
    });
    this.subs.push(sub4);
  }


  ngOnInit(): void {
    this.getEventDetail();
    if (this.baseUrl != '')
      this.scoreData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  openModal(template: TemplateRef<any>, key: any) {
    let cls = (key == 'book') ? 'modal-dialog bookModal' : (key == 'rule') ? 'modal-dialog modal-dialog-scrollable rulesModaldetail' : ''
    let id = (key == 'bets') ? 'MobileStakes' : ''
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: cls }, { id: id })
    );
  }

  timeBetweenDates(toDate: Date, currentDate: Date) {
    var dateEntered = toDate;
    var now = new Date();
    var difference = dateEntered.getTime() - now.getTime();
    let str = '';

    if (difference <= 0) {

      // Timer done
      clearInterval(this.raceTimer);

    } else {

      var seconds = Math.floor(difference / 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);
      var days = Math.floor(hours / 24);

      hours %= 24;
      minutes %= 60;
      seconds %= 60;
      str = `Bet Starts in (${days != 0 ? days + ':' : ''}${hours}:${minutes}:${seconds})`
    }
    this.raceTimer = (toDate.getTime() == currentDate.getTime()) ? '' : str;
  }

  getEventDetail() {
    this.isLoading = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.eventDetail}/${this.actRoute.snapshot.paramMap.get('id')}/detail`).subscribe(
      (res) => {
        if (res.status == true) {

          if (this.isCollapsed.markets.length == 0) {
            this.isCollapsed.markets = Array(res.data.event.markets.length).fill(false) as any;
          } else {
            let market = Array(res.data.event.markets.length).fill(false) as any;
            market.forEach((element: any, i: any) => {
              element = this.isCollapsed.markets[i] ? this.isCollapsed.markets[i] : element;
            });
          }

          if (this.isCollapsed.book_makers.length == 0) {
            this.isCollapsed.book_makers = Array(res.data.event.book_makers.length).fill(false) as any;
          } else {
            let bookmaker = Array(res.data.event.book_makers.length).fill(false) as any;
            bookmaker.forEach((element: any, i: any) => {
              element = this.isCollapsed.book_makers[i] ? this.isCollapsed.book_makers[i] : element;
            });
          }
          this.multiMarketIds = [];
          res.data.event.fancy = res.data.event.fancy == null ? [] : res.data.event.fancy;
          res.data.event.book_makers = res.data.event.book_makers == null ? [] : res.data.event.book_makers;
          res.data.event.markets = res.data.event.markets == null ? [] : res.data.event.markets;
          this.fancyTab = JSON.parse(res.data.fancy_tab);
          let all: any[] = [];
          if (res?.data?.multi_markets)
            res?.data?.multi_markets.forEach((element: any) => {
              this.multiMarketIds.push(element.market_id)
            });
          res.data.event.fancy.forEach((element: any) => {
            all.push(element.sort_priority);
          });

          res.data.event.markets.forEach((element: any) => {
            // Race time update with related race-market time
            if (this.mId && this.mId != null && element.market_id == this.mId) {
              res.data.event.event['market_start_time'] = element.market_start_time;

              // countDown timer for racing data
              let mktDate = this.subtractMinutes(Number(res.data.bet_unlock_before_time) + 1, new Date(element.market_start_time))
              let currentDate = this.subtractMinutes(Number(res.data.bet_unlock_before_time) + 1, new Date())
              element['bet_start_in'] = setInterval(() => {
                this.timeBetweenDates(mktDate, currentDate);
              }, 1000);
              element['bet_open'] = (mktDate.getTime() <= new Date().getTime()) ? true : false;

            }

            element.runners.forEach((rData: any) => {
              rData.meta_data = JSON.parse(rData.meta_data);
            });
          });
          // Object.keys(this.fancyTab).forEach(key => {
          //   all = [...all, ...this.fancyTab[key]];
          // })
          const uniqueSet = new Set(all);
          all = [...uniqueSet];
          this.fancyTab['all'] = all;
          // console.log(this.fancyTab);
          if (this.data) {
            this.data = this.compareAndSetEventData(this.data, res.data);
          } else {
            this.data = res.data;
          }

          this.fLineMrk = (res.data.event.fancy.length > 0) ? res.data.event.fancy.some((e: any) => e.fancy_type == 'LINE') : false;
          this.fFancyMrk = (res.data.event.fancy.length > 0) ? res.data.event.fancy.some((e: any) => e.fancy_type != 'LINE') : false;
          // console.log(this.data);
          // console.log(this.oodsList);
          // console.log(this.marketsReq);

          this.baseUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
          this.data = this.setDateFormate(this.data);
          this.marketsReq = this.createMarketIdList(this.data.event) as any;
          this.marketIds = this.createMarketIds(this.data.event) as any;
          this.token = this.data.token;
          this._shared.nextMessage(this.data?.message);
          if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
            this.newOddsEnable = true;
            this.getOddsNew(this.marketsReq, this.data, true);
          } else {
            this.newOddsEnable = false;
            this.getOdds(this.marketsReq, this.data, true);
          }
          this.getExposure(this.marketsReq, this.data);
          // this.getOdds(this.marketsReq, this.data, true);
        } else {
          if (res.error.code == 1001) {
            this._message.errmessage(res.data.message);
            this.router.navigate(['/dashboard']);
          }
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getEventDetailOnly() {
    // console.log("eventonly");
    if (this.data?.event) {
    this.getServices().Post(`${this.env.baseUrl + this.api.eventDetailOnly}/${this.actRoute.snapshot.paramMap.get('id')}`, '').subscribe(
      (res) => {
        if (res.status == true) {

          if (this.isCollapsed.markets.length == 0) {
            this.isCollapsed.markets = Array(res.data.event.markets.length).fill(false) as any;
          } else {
            let market = Array(res.data.event.markets.length).fill(false) as any;
            market.forEach((element: any, i: any) => {
              element = this.isCollapsed.markets[i] ? this.isCollapsed.markets[i] : element;
            });
          }

          if (this.isCollapsed.book_makers.length == 0) {
            this.isCollapsed.book_makers = Array(res.data.event.book_makers.length).fill(false) as any;
          } else {
            let bookmaker = Array(res.data.event.book_makers.length).fill(false) as any;
            bookmaker.forEach((element: any, i: any) => {
              element = this.isCollapsed.book_makers[i] ? this.isCollapsed.book_makers[i] : element;
            });
          }
          // this.data = res.data;
          res.data.event.fancy = res.data.event.fancy == null ? [] : res.data.event.fancy;
          res.data.event.book_makers = res.data.event.book_makers == null ? [] : res.data.event.book_makers;
          res.data.event.markets = res.data.event.markets == null ? [] : res.data.event.markets;
          if (this.data) {
            this.data = this.compareAndSetEventData(this.data, res.data);
          } else {
            this.data = res.data;
          }

          this.fancyTab = res.data.fancy_tab;
          let all: any[] = [];
          if (res?.data?.multi_markets)
            res?.data?.multi_markets.forEach((element: any) => {
              this.multiMarketIds.push(element.market_id)
            });
          res.data.event.fancy.forEach((element: any) => {
            all.push(element.sort_priority);
          });

          res.data.event.markets.forEach((element: any) => {
            // Race time update with related race-market time
            if (this.mId && this.mId != null && element.market_id == this.mId) {
              res.data.event.event['market_start_time'] = element.market_start_time;

              // countDown timer for racing data
              let mktDate = this.subtractMinutes(Number(res.data.bet_unlock_before_time) + 1, new Date(element.market_start_time))
              let currentDate = this.subtractMinutes(Number(res.data.bet_unlock_before_time) + 1, new Date())
              element['bet_start_in'] = setInterval(() => {
                this.timeBetweenDates(mktDate, currentDate);
              }, 1000);
              element['bet_open'] = (mktDate.getTime() <= new Date().getTime()) ? true : false;

            }

            element.runners.forEach((rData: any) => {
              rData.meta_data = JSON.parse(rData.meta_data);
            });
          });
          // Object.keys(this.fancyTab).forEach(key => {
          //   all = [...all, ...this.fancyTab[key]];
          // })
          const uniqueSet = new Set(all);
          all = [...uniqueSet];
          this.fancyTab['all'] = all;

          if (this.data) {
            this.data = this.compareAndSetEventData(this.data, res.data);
          } else {
            this.data = res.data;
          }

          this.fLineMrk = (res.data.event.fancy.length > 0) ? res.data.event.fancy.some((e: any) => e.fancy_type == 'LINE') : false;
          this.data = this.setDateFormate(this.data);
          this.fFancyMrk = (res.data.event.fancy.length > 0) ? res.data.event.fancy.some((e: any) => e.fancy_type != 'LINE') : false;
          this.data = this.setDateFormate(this.data);
          // this.data = this.setExposeData(this.data, this.data.exposes);

          this.marketsReq = this.createMarketIdList(this.data.event) as any;
          this.marketIds = this.createMarketIds(this.data.event) as any;

          if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
            this.newOddsEnable = true;
            this.getOddsNew(this.marketsReq, this.data, true);
          } else {
            this.newOddsEnable = false;
            this.getOdds(this.marketsReq, this.data, true);
          }
          this.getExposure(this.marketsReq, this.data);
        }
      },
      (err) => {
        console.log(err);
      });
    } else {
      console.log('event detail only prevented due to no data.event found')
    }

  }

  getOdds(req: any, items: any, isDetail: boolean) {
    this.getServices().PostWithUrlEncoded(`${this.baseUrl + this.api.odds}`, req).subscribe(
      (res) => {
        res = this._common.string_to_JSON(res);
        this.oodsList = this._common.compareData(res, this.oodsList);
        let odds = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));
        this.setOdds(odds);

        if (items) {
          if (items.event.fancy != null)
            items.event.fancy.sort((a: any, b: any) => parseFloat(a.sort_priority) - parseFloat(b.sort_priority));
          this.isCollapsed.markets = Array(items.event.markets.length).fill(false) as any;
          this.data = items;
          this.isLoading = false;

        }
      },
      (err) => {
        console.log(err);
      });
  }

  oddsLisDisNew: any = {};

  getOddsNew(req: any, items: any, isDetail: boolean) {

    this.getServices().PostWithUrlEncoded(`${this.baseUrl + this.api.oddsNew}`, req).subscribe(
      (res) => {
        res = this._common.pipe_string_to_JSON(res);
        let resOdds: any = this._common.arrangeGetMarketNewData(res, items);

        //compare list
        this.oodsList = this._common.compareData(Object.keys(resOdds).map(key => (resOdds[key])), this.oodsList);

        if (this.oddsLisDisNew.length == 0) {
          this.oddsLisDisNew = resOdds;
        } else {
          let newOddsLD = resOdds;
          Object.keys(newOddsLD).forEach(key => {
            if (Object.keys(this.oddsLisDisNew).includes(key)) {
              delete this.oddsLisDisNew[key];
            }
          });
          this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
        }

        this.setOdds(this.oddsLisDisNew);

        if (items) {
          if (items.event.fancy != null)
            items.event.fancy.sort((a: any, b: any) => parseFloat(a.sort_priority) - parseFloat(b.sort_priority));
          this.data = items;
          this.isLoading = false;
        }
      },
      (err) => {
        console.log(err);
      });
  }

  setOdds(item: any) {

    Object.keys(item).forEach((key: any) => {
      if (item[key].runners) {
        let temp = Object.assign({}, ...item[key].runners.map((elt: any) => ({ [elt.selectionId]: elt })));
        item[key]['cRunners'] = temp;
      }
      if (item[key].book_maker_odds) {
        let temp = Object.assign({}, ...item[key].book_maker_odds.map((elt: any) => ({ [elt.selection_id]: elt })));
        item[key]['cRunners'] = temp;
      }
    });

    this.oddsLisDis = item;
    this.betSlipData['oddsLisDis'] = item;

  }

  tempExpo: any[] = [];
  getExposure(req: any, items: any) {
    let user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
    let uid = this.actRoute.snapshot.paramMap.get('uid') ? this.actRoute.snapshot.paramMap.get('uid') : user?.id;
    this.getServices().PostWithUrlEncoded(`${this.env.baseUrl + this.api.exposure}/${uid}`, req).subscribe(
      (res) => {
        if (res.status == true) {
          this.tempExpo = res.data.temp_expose ? res.data.temp_expose : [];
          res = res.data.exposes;
          res = this._common.string_to_JSON(res);
          items = this.setExposeData(items, res);
          this.data = items;
          this.isLoading = false;
        }
      },
      (err) => {
        console.log(err);
      });
  }

  setExposeData(items: any, res: any) {
    if (items && res) {
      // average expose
      res.forEach((element: any) => {
        element.forEach((expo: any, i: any) => {
          // console.log(this.tempExpo);
          // temp_exposure logic
          this.tempExpo.forEach((tEle: any) => {
            if (tEle && tEle?.market_id == expo?.market_id && tEle[`${expo?.selection_id}_expose`]) {
              if (tEle?.market_id[0] == '9') {
                expo.expose = Number(tEle[`${expo?.selection_id}_expose`]);
              } else {
                expo.expose += Number(tEle[`${expo?.selection_id}_expose`]);
              }
              // expo.expose = expo.expose.toFixed(2);
            }
          });
        });
      });
      res.forEach((element: any) => {
        element.forEach((expo: any, i: any) => {

          if (element.length == 2) {
            if (i == 0) {
              let avg_value: any;
              avg_value = Math.abs((parseFloat(element[0].expose) / parseFloat(element[1].expose))).toFixed(2);
              if (!isFinite(avg_value)) {
                element[i]["average"] = '';
                element[i]["avg"] = 0;
              } else {
                element[i]["average"] = ' (' + avg_value + ')';
                element[i]["avg"] = Number(avg_value);
              }

            } else {
              let avg_value: any;
              avg_value = Math.abs((parseFloat(element[1].expose) / parseFloat(element[0].expose))).toFixed(2);
              if (!isFinite(avg_value)) {
                element[i]["average"] = '';
                element[i]["avg"] = 0;
              } else {
                element[i]["average"] = ' (' + avg_value + ')';
                element[i]["avg"] = Number(avg_value);
              }
            }
          }
          //
          // // temp_exposure logic
          // this.tempExpo.forEach((tEle: any) => {
          //   if (tEle && tEle?.market_id == expo?.market_id && tEle[`${expo?.selection_id}_expose`]) {
          //     expo.expose += Number(tEle[`${expo?.selection_id}_expose`]);
          //   }
          // });
        });

      });


      res.forEach((element: any) => {
        let temp = Object.assign({}, ...element.map((elt: any) => ({ [elt.selection_id]: elt })));
        this.exposLisDis[element[0]?.marketId ? element[0]?.marketId : element[0]?.market_id] = temp;
      });

    }

    return items;
  }

  combineBook: any[] = [];
  genCombineBook() {
    let cb: any[] = [];
    let isShow: boolean = false;
    this.data?.event?.match_odds.runners.forEach((ele: any) => {
      cb.push({
        'name': ele.name,
        'selection_id': ele.selection_id,
        'market_id': ele.market_id,
        'expose': 0,
        'avg': 0
      })
    });

    if (this.exposLisDis) {
      Object.keys(this.exposLisDis).forEach(key => {
        Object.keys(this.exposLisDis[key]).forEach(runer => {
          if (this.exposLisDis[key][runer].market_type_id == "MATCH_ODDS" || this.exposLisDis[key][runer].market_type_id == "BOOK_MAKER") {

            cb.forEach(ele => {
              if (ele.selection_id == this.exposLisDis[key][runer].selection_id) {
                if (this.exposLisDis[key][runer].market_id && (this.oddsLisDis[this.exposLisDis[key][runer].market_id]?.status == 1 || this.oddsLisDis[this.exposLisDis[key][runer].market_id]?.status == 'OPEN')) {
                  isShow = true;
                  ele.expose += this.exposLisDis[key][runer]?.expose;
                  if (this.exposLisDis[key][runer]?.avg)
                    ele.avg = (this.exposLisDis[key][runer]?.expose < 0) ? ele.avg - this.exposLisDis[key][runer]?.avg : ele.avg + this.exposLisDis[key][runer]?.avg;
                }
              }
            });
          }
        });
      });
    }
    this.combineBook = (isShow) ? cb : [];

  }

  compareAndSetEventData(oldItems: any, resItems: any) {
    // console.log(oldItems);
    // console.log(resItems);

    Object.keys(resItems.event).forEach(key => {
      resItems = this.setExposeData(resItems, oldItems?.exposes);
      // resItems = this.setOddsData(resItems, this.oodsList);
      oldItems.event.event = resItems?.event?.event;

      if (typeof (resItems.event[key]) == 'object' && resItems.event[key]?.market_id && oldItems.event[key]?.market_id) {
        oldItems.event[key] = resItems.event[key];
      } else if (Array.isArray(resItems.event[key])) {
        oldItems.event[key] = resItems.event[key];
      }
    });
    return oldItems;
  }

  scoreData() {
    let tempReq = { "event_id": this.actRoute.snapshot.paramMap.get('id') }
    let req = this._common.JSON_to_URLEncoded(tempReq);
    this.getServices().htmlResponse(`${this.baseUrl + this.api.scoreData}`, req).subscribe(
      (res) => {
        this.scoreHtml = res;
      },
      (err) => {
        console.log(err)
      });
  }

  tvData(e: any) {
    if (e == 'desktop') {
      this.isCollapsed.tv.desktop = !this.isCollapsed.tv.desktop;
    } else {
      this.isCollapsed.tv.mobile = !this.isCollapsed.tv.mobile;
    }

    // alert(this.data.event?.event?.tv_provider); //flash
    // alert(this.data.event?.event?.tv_channel); //Tkp_647501
    // alert(this.data.tv_domain); //ndexch.com
    
    let doc = this.document.getElementById(`${e == 'desktop' ? 'tv-block-id-desk' : 'tv-block-id-mob'}`) as HTMLElement;
    if ((this.isCollapsed.tv.desktop == false && e == 'desktop') || (this.isCollapsed.tv.mobile == false && e == 'mobile')) {
      if (this.data.event?.event?.tv_provider == 'ftlive1') {
        this.http.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
          let ipAddress = res.ip;
          this.iframeURL = `${this.env.host.ftLivetvData}${this.data.event?.event?.tv_channel}&ip=${ipAddress}`;
          doc.innerHTML = `<iframe src="${this.iframeURL}" class="LiveStream-video-col"></iframe>`
        });
      } else if (this.data.event?.event?.tv_provider == 'flash') {
        if (this.data?.tv_domain) {
          const head = this.document.getElementsByTagName('head')[0];
          const style = this.document.createElement('link');
          style.rel = 'stylesheet';
          style.href = `https://speedcdn.io/flashphoner/css/flashphoner.bundle.min.css`;
          head.appendChild(style);
          let inHtml = `<div id="live" class="video" style="overflow: hidden"></div>
        <script type="text/javascript" src="https://speedcdn.io/flashphoner/js/flashphoner.bundle.min.js"></script>
        <script>
            $(document).ready(function () {
                init_player('#live', "${this.data.event?.event?.tv_channel}", 'wss://${this.data?.tv_domain}:8443', false, 0);
            });
        </script>`;
          this.setInnerHTML(doc, inHtml);
        } else {
          doc.innerHTML = `<div>TV Not Available</div>`;
        }
      } else if (this.data.event?.event?.tv_provider == 'iframe') {
        doc.innerHTML = ` <iframe src="${this.data.event?.event?.tv_channel}" class="LiveStream-video-col"></iframe>`
      }
    } else if ((this.isCollapsed.tv.desktop == true && e == 'desktop') || (this.isCollapsed.tv.mobile == true && e == 'mobile')) {
      this.iframeURL = '';
      this.isCollapsed.tv.desktop = this.isCollapsed.tv.mobile = true;
    }
  }

  setInnerHTML(elm: any, html: any) {
    elm.innerHTML = html;
    Array.from(elm.querySelectorAll("script")).forEach((oldScript: any) => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach((attr: any) => { if (attr.name || attr.value) { newScript.setAttribute(attr.name, attr.value) } });
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  // tvData(e: any) {
  //   if (e == 'desktop') {
  //     this.isCollapsed.tv.desktop = !this.isCollapsed.tv.desktop;
  //   } else {
  //     this.isCollapsed.tv.mobile = !this.isCollapsed.tv.mobile;
  //   }
  //   if ((this.isCollapsed.tv.desktop == false && e == 'desktop') || (this.isCollapsed.tv.mobile == false && e == 'mobile')) {
  //     this.getServices().htmlResponse(`${this.env.baseUrl + this.api.tvData}/${this.actRoute.snapshot.paramMap.get('id')}`, '').subscribe(
  //       (res) => {
  //         this.tvSteam = res;
  //         let elm = document.getElementById('tvStr') as HTMLElement;
  //         this.setInnerHTML(elm, res);
  //       },
  //       (err) => {
  //         console.log(err)
  //       });
  //   } else if ((this.isCollapsed.tv.desktop == true && e == 'desktop') || (this.isCollapsed.tv.mobile == true && e == 'mobile')) {
  //     this.tvSteam = '';
  //     this.isCollapsed.tv.desktop = this.isCollapsed.tv.mobile = true;
  //   }
  // }

  // setInnerHTML(elm: any, html: any) {
  //   elm.innerHTML = html;
  //   Array.from(elm.querySelectorAll("script")).forEach((oldScript: any) => {
  //     const newScript = document.createElement("script");
  //     Array.from(oldScript.attributes).forEach((attr: any) => {
  //       if (attr.name || attr.value) {
  //         newScript.setAttribute(attr.name, attr.value)
  //       }
  //     });
  //     newScript.appendChild(document.createTextNode(oldScript.innerHTML));
  //     oldScript.parentNode.replaceChild(newScript, oldScript);
  //   });
  // }

  fancyRunPosition(template: TemplateRef<any>, item: any) {
    if (this.exposLisDis[item?.market_id] && this.exposLisDis[item?.market_id][item?.selection_id]) {
      this.openModal(template, 'book');
      let uid = this.actRoute.snapshot.paramMap.get('uid') ? this.actRoute.snapshot.paramMap.get('uid') : this.user?.id;
      this.getServices().Get(`${this.env.baseUrl + this.api.fancyRunPosition}/${uid}/${item?.market_id}`).subscribe(
        (res) => {
          if (res.status == true) {
            this.fancyRun = JSON.parse(res.data.data);
            this.fancyRun = Object.values(this.fancyRun)
          } else {
            this._common.checkForForceChangePassword(res);
          }
        },
        (err) => {
          console.log(err)
        });
    }
  }

  openBetPlace(item: any, oodsIitem: any, i: any, bet: any, oi: any, bkOrLy: any, key: string) {
    // let data = this.betSlipData = this._common.getBetSlipData(item, oodsIitem, i, bet, oi, bkOrLy, key, this.token);
    // console.log(this.betSlipData);

    // if (data && data?.price ) {
    //   data['event_name'] = this.data?.event?.event?.name;
    //   this.betSlipModal?.show();
    // } else {
    //   this.betSlipData = {}
    // }
  }

  setDateFormate(res: any) {
    res.event.book_makers = (res.event.book_makers != null) ? this._common.UTC_to_Local_timeZone(res.event.book_makers) : [];
    // res.event.event = (res.event.event != null) ? this._common.UTC_to_Local_timeZone(res.event.event) : {};
    res.event.fancy = (res.event.fancy != null) ? this._common.UTC_to_Local_timeZone(res.event.fancy) : [];
    res.event.markets = (res.event.markets != null) ? this._common.UTC_to_Local_timeZone(res.event.markets) : [];
    res.event.match_odds = (res.event.match_odds != null) ? this._common.UTC_to_Local_timeZone(res.event.match_odds) : {};

    return res;
  }

  createMarketIdList(items: any) {
    let market: any[] = [];
    Object.keys(items).forEach(key => {
      if (typeof (items[key]) == 'object' && items[key]?.market_id) {
        market.push('market_ids[]=' + encodeURIComponent(items[key]?.market_id))
      } else if (Array.isArray(items[key])) {
        items[key].forEach((element: any) => {
          if (element.market_id) {
            market.push('market_ids[]=' + encodeURIComponent(element?.market_id))
          }
        });
      }
    });

    const uniqueSet = new Set(market);
    market = [...uniqueSet];
    // console.log(market);

    return market.join('&');
  }

  createMarketIds(items: any) {
    let market: any[] = [];
    Object.keys(items).forEach(key => {
      if (typeof (items[key]) == 'object' && items[key]?.market_id) {
        market.push(items[key]?.market_id)
      } else if (Array.isArray(items[key])) {
        items[key].forEach((element: any) => {
          if (element.market_id) {
            market.push(element?.market_id)
          }
        });
      }
    });

    const uniqueSet = new Set(market);
    market = [...uniqueSet];
    // console.log(market);

    return market;
  }


  closeBet(e: any) {
    this.betSlipModal?.hide();
    this.nextExpoList = {}
    // this.betRunnerData.isClosed = true;
  }

  updateData(e: any) {
    this.token = e;
    this.betSlipData = {};
  }

  changeExpo(data: any) {
    // console.log(data);

    data?.runners.forEach((element: any) => {
      if (element?.selectionId)
        this.nextExpoList[`${data?.market_id}-${element?.selectionId}`] = element.pnlNext;
      if (element?.selection_id)
        this.nextExpoList[`${data?.market_id}-${element?.selection_id}`] = element.pnlNext;

    });
    // console.log(this.nextExpoList);

  }

  onSelectMobTab(key: any) {
    // console.log(key);

    if (key == 'market') {
      this.isMobMarket = true;
      this.isCollapsed.tv.mobile = false
    } else if (key == 'tv') {
      this.isMobMarket = true;
      this.tvData('mobile');
    } else if (key == 'bets') {
      this.isMobMarket = false;
      this.isCollapsed.tv.mobile = false
    }
  }

  multiMarketUpdate(item: any, key: any) {
    // console.log(item);
    let url = (key == 'save') ? `${this.api.saveMultiMarket}/${item?.market_id}/${item?.event_id}/${item?.market_type_id}/${this.data?.event?.event?.event_type_id}` : `${this.api.removeMultiMarket}/${item?.market_id}`;

    this.getServices().Get(`${this.env.baseUrl + this.api.multiMarket + url}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (key == 'save') {
            this.multiMarketIds.push(item?.market_id)
          } else {
            const index = this.multiMarketIds.indexOf(item?.market_id);
            if (index > -1) {
              this.multiMarketIds.splice(index, 1); // 2nd parameter means remove one item only
            }
            // this.multiMarketIds = this.multiMarketIds.filter(item => item !== item?.market_id)
          }
          // this.fancyRun = JSON.parse(res.data.position);
        }
      },
      (err) => {
        console.log(err)
      });
  }

  openBook(item: any, key: any) {
    this.bookModal?.show();
    let uid = this.actRoute.snapshot.paramMap.get('uid') ? this.actRoute.snapshot.paramMap.get('uid') : this.userData?.id;
    this.getServices().Get(`${this.env.baseUrl + (key == 'odds' ? this.api.matchOddBook : this.api.bookMakerBook)}/${uid}/${item?.event_id}/${item?.market_id}`).subscribe(
      (res) => {
        if (res.status == true) {
          // console.log(res);
          let total: any[] = [];
          if (res.data.exposes) {
            res.data.exposes = Object.values(res?.data?.exposes);

            res?.data?.exposes.forEach((element: any) => {
              element.forEach((exp: any, i: any) => {
                exp.parent_book = (exp?.user?.role_id == 4) ? -exp.parent_book : exp.parent_book;
                if (total[i] === undefined) {
                  total[i] = parseInt(exp.parent_book);
                } else {
                  total[i] += parseInt(exp.parent_book)
                }
              });
            });
          }

          // res?.data?.own_expose.forEach((exp: any, i: any) => {
          //   if (total[i] === undefined) {
          //     total[i] = parseInt(exp.parent_book);
          //   } else {
          //     total[i] += parseInt(exp.parent_book)
          //   }
          // });
          this.bookDetail = res?.data;
          this.bookDetail["total"] = total;


          if (key == 'odds') {
            this.bookDetail["header"] = res?.data?.event?.markets.filter((market: any) => market.market_id == item?.market_id)[0];
          } else if (key == 'bookmaker') {
            this.bookDetail["header"] = res?.data?.event?.book_makers.filter((market: any) => market.market_id == item?.market_id)[0];
          }
          // console.log(this.bookDetail);
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err)
      });
  }

  openSettingModal(e: any) {
    this._common.openModalWithComponent(e, SettingComponent, 'bookModal');
  }

  detailPage(uid: any) {
    this.bookModal?.hide();
    this.router.navigate(['event/detail', this.actRoute.snapshot.paramMap.get('id'), uid])
  }

  isInclude(tabVals: any, priority: any) {
    return tabVals.includes(priority);
  }

  isCommon(a: any, b: any) {
    return a.filter((o1: any) => b.some((o2: any) => o1 == o2)).length == 0;
  }

  volumeMultiSize(size: any, multi: any) {
    let num = (multi) ? Number(size) * Number(multi) : size;
    return (num % 1 != 0) ? num.toFixed(2) : num;
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
    this._pusher.unsubscribeChannel(`event-${this.actRoute.snapshot.paramMap.get('id')}`);
    let user = (localStorage.getItem(`${environment.panel}user`)) ? JSON.parse(localStorage.getItem(`${environment.panel}user`) as any) : ""
    this._pusher.unsubscribeChannel(`private-expose.${this.actRoute.snapshot.paramMap.get('id')}.${this.actRoute.snapshot.paramMap.get('uid') ? this.actRoute.snapshot.paramMap.get('uid') : this.user.id}`)
  }

}
